import Head from 'next/head'
import { PageHeader } from 'components/PublicComponents/PageHeader'
import { AuthForm } from '../styles'
import { Wrapper } from '../../../styles/styleSystem/wrapper'
import { Text, TEXT_SEMANTIC_VARIANTS } from '../../../components/Text'
import { useRouter } from 'next/router'
import { PageWrapper } from 'containers/styles'

export const InvalidLinkPage = () => {
  const router = useRouter()
  const handleRedirectToHome = () => {
    router.push('/')
  }

  return (
    <PageWrapper>
      <Head>
        <title>Fintros | Reset Password</title>
      </Head>
      <PageHeader />
      <Wrapper mt={6}>
        <AuthForm>
          <Wrapper textCenter display="flex" alignItems="center" spacing={16}>
            <Text as={TEXT_SEMANTIC_VARIANTS.h2} size="xl" weight="light">
              This link has expired or has already been used.
            </Text>
            <Text
              as={TEXT_SEMANTIC_VARIANTS.button}
              onClick={handleRedirectToHome}
            >
              Go Home
            </Text>
          </Wrapper>
        </AuthForm>
      </Wrapper>
    </PageWrapper>
  )
}
